// Color que identifica a cada disciplina (calendario y mapa de lugares).
const TYPE_COLORS = {
  Ride: 'var(--light-blue)',
  'Indoor Cycling': 'var(--light-blue)',
  Train: 'var(--secondary-color)',
  Yoga: '#7c5cbf',
  'Pilates Mat': '#2baa72',
  Barre: '#d4527a',
  'Sculpt and Burn': '#f0dc8a',
  'Jump Fitness': '#a0714f',
  'Dance Fit': '#f2883a',
};

// Disciplinas con color claro que necesitan texto oscuro encima.
const DARK_TEXT_TYPES = ['Sculpt and Burn'];

export const typeColor = (type) => TYPE_COLORS[type] ?? '#888';

export const typeTextColor = (type) =>
  DARK_TEXT_TYPES.includes(type) ? 'var(--black)' : 'var(--white)';
